// extracted by mini-css-extract-plugin
export default {"container":"XY-z","title":"YY-z","link":"ZY-z"};